import React from "react";
import PropTypes from "prop-types";
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import OKIcon from "@material-ui/icons/CheckCircleOutline";
import bot from "assets/img/bot_Munkong_Panel.png";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import "../Dashboard/dashboard.css";

import axios from "axios";
import conf from "../../conf.json";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    let data = JSON.parse(localStorage.getItem("data"));
    let status = "";
    this.reqPer = this.reqPer.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.getAccountAll();
    if (data.acstatus === "2") status = "Admin CallCenter";
    if (data.acstatus === "1") status = "CallCenter";
    if (data.acstatus === "4") status = "Sale";
    if (data.acstatus === "3") status = "Admin Sale";
    if (data.acstatus === "10") status = "Super Admin";
    this.state = {
      selectsale: "",
      status: status,
      accounts:[],
      approve_by: "none"
    };
  }
  getAccountAll(){
    axios
      .get(conf.url + "/account")
      .then(res=>{
        let accounts = res.data.data.map((data, index) => {
          return (
            <MenuItem key={index} value={data.acusername}>
              {data.acfirstname + " " + data.aclastname}
            </MenuItem>
          );
        });
        this.setState({
          accounts: accounts
        })
      })
  }
  handleSelectChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  reqPer(){
    this.updatePermission();
    //this.state.selectsale
  }
  updatePermission() {
    const params = {
      token: localStorage.getItem("token"),
      status: this.state.selectsale,
      approve_by: this.state.approve_by

    };
    axios
      .put(conf.url + "/permission", JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        localStorage.clear("token");
        localStorage.clear("data");
        window.location.assign("/");
        alert("ขอสิทธิ์เรียบร้อยแล้ว ท่านจะสามารถใช้งานได้ต่อเมื่อ admin ทำการอนุมัติ");
      }).catch(er=>{
        alert("ไม่สามารถขอสิทธิ์ได้")
      });
  }
  handleSimple = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="warning">
                <h4 className={classes.cardTitleWhite}>เลือกสิทธิ์ผู้ใช้งาน</h4>
                <b>[ปัจจุบันสิทธิ์ของคุณคือ {this.state.status}]</b>
              </CardHeader>
              <CardBody>
                <div className="mt-4" />
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="simple-select"
                    className={classes.selectLabel}
                  >
                    ตำแหน่ง
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={this.state.selectsale}
                    onChange={this.handleSimple}
                    inputProps={{
                      name: "selectsale",
                      id: "selectsale"
                    }}
                  >
                     <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="10"
                    >
                      Admin
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="1"
                    >
                      Call Center
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="2"
                    >
                      Admin Call Center
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="4"
                    >
                      Sale
                    </MenuItem>
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }}
                      value="3"
                    >
                      Admin Sale
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel
                    htmlFor="simple-select"
                    className={classes.selectLabel}
                  >
                    เลือกผู้ Approve
                  </InputLabel>
                  <Select
                                 inputProps={{
                                  name: "approve_by",
                                  id: "approve_by"
                                }}
                                MenuProps={{
                                  className: classes.selectMenu
                                }}
                                classes={{
                                  select: classes.select
                                }}
                                value={this.state.approve_by}
                                onChange={this.handleSelectChange}
                              >
                                 <MenuItem key={-2} value={"none"}>
                                  {"- ไม่มี -"}
                                </MenuItem>
                             
                                {this.state.accounts}
                              </Select>
                  
                </FormControl>
                <div className="text-right" style={{ margin: 10 }}>
                  <Button
                    disabled={this.state.selectsale !== "" ? false : true}
                    onClick={this.reqPer}
                    className="float-right"
                    style={{ marginRight: 20 }}
                    variant="contained"
                    color="primary"
                    className={classes.button}
                  >
                    ขอสิทธิ์
                    <OKIcon className={classes.rightIcon} />
                  </Button>
                </div>
                <div class="text-center w-75 m-auto">
                        <span><img  width="200" src={bot} alt="logo" className={classes.img} /></span><br />
                        <span style={{color:"red",fontWeight:"bold"}}>QR-Code สำหรับรับการแจ้งเตือนจากระบบ</span><br />
                        <span>1. Download แอพ OneChat ทำการ Sign in ด้วยบัญชี One ID</span><br />
                        <span>2. สแกน QR Code เพิ่มเพื่อน Chat Bot : INET CVM เพื่อรับการแจ้งเตือนจากระบบ</span>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/RequestPermission/RequestPermossion.jsx